// Joins the names or presents a dash if the list is empty.
// Ideally we would use Intl.ListFormat, but it's raising errors on some mobile devices, due to lack
// of support:
// const listFormatter = new Intl.ListFormat('de', { style: 'long', type: 'conjunction' });
// const message = listFormatter.format(names) || '—';
//
// For now we will use this custom implementation :(
export function formatStylistNames(names: string[]): string {
  const [first, ...rest] = names;

  if (!first) {
    return '—';
  }

  if (!rest || rest.length === 0) {
    return first;
  }

  return `${rest.join(', ')} und ${first}`;
}

// This function is responsible for grabbing the initials of the first and last name
export function getStylistInitials(stylistName: string): string {
  return (
    stylistName
      .match(/(\b\S)?/g)
      ?.join('')
      .match(/(^\S|\S$)?/g)
      ?.join('')
      .toUpperCase() || ''
  );
}
